// extracted by mini-css-extract-plugin
export default {"chip":"TrayRankingStatusChip_chip__oTXP1","enabled":"TrayRankingStatusChip_enabled__0kvPr","disabled":"TrayRankingStatusChip_disabled__mnhA8"};